export default {
  props: {
    bus: Object,
    data: Object
  },
  render(h) {
    return this.bus.chart.processContent(h, this.data)
  }
}